module.exports = __webpack_public_path__ + "img/serifnew_box19.7a873afd.jpg";